import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Drawer from '@material-ui/core/Drawer';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

import Divider from '@material-ui/core/Divider';

import { Badge } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ReportIcon from '@material-ui/icons/Assignment';
import TimeClockIcon from '@material-ui/icons/Schedule';
import CalendarIcon from '@material-ui/icons/Event';
import SettingsIcon from '@material-ui/icons/Settings';
import DateRangeIcon from '@material-ui/icons/DateRange';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import AuthUserContainer from '../containers/AuthUser';

import { MuiThemeProvider, withStyles } from '@material-ui/core/styles';
import { darkTheme } from '../themes';
import { Link } from 'react-router-dom';
import { Route } from 'react-router-dom';
import sphereLogoWhiteText from '../images/logos/sphere_whiteText.svg';
import ticketIcon from '../images/icons/ticketsIcon.svg';
import accountingIcon from '../images/icons/accounting.svg';
import dispatchIcon from '../images/icons/dispatchIcon.svg';
import { isPtoHr } from '../pages/Pto/util';

const styles = {
	icon: {
		margin: 0,
	},
	iconText: {
		paddingLeft: 8,
		paddingTop: 2,
		color: 'white',
	},
	selected: {
		backgroundColor: '#2b95f3',
		height: '3px',
		margin: '0px 16px',
		top: '-4px',
		position: 'relative',
		transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
	},
	nested: {
		paddingLeft: 18,
		marginTop: -10,
		marginBottom: -10,
	},
	nestedRoot: {
		paddingLeft: 5,
		color: '#fff',
	},
	nestedText: {
		fontWeight: 100,
		color: '#fff',
		lineHeight: 1.3,
	},
	nestedIcon: {
		borderBottom: '1px solid white',
		borderLeft: '1px solid white',
		margin: 0,
		position: 'relative',
		opacity: 0.4,
		top: -10,
		left: -7,
		width: 18,
		height: 18,
	},
	tightIcon: {
		marginRight: 0,
		minWidth: 'auto',
	},
	logoContainer: {
		width: '100%',
		paddingTop: 20,
		paddingLeft: 15,
		paddingRight: 15,
		boxSizing: 'border-box',
	},
	logo: {
		width: '100%',
	},
	logoSubText: {
		paddingTop: 5,
		letterSpacing: '-.1px',
		color: '#eee',
		fontWeight: 200,
		textTransform: 'uppercase',
		fontSize: 11,
		whiteSpace: 'noWrap',
		paddingBottom: 20,
	},
	loginContainer: {
		paddingTop: 30,
		paddingLeft: 18,
		paddingBottom: 3,
	},
	loginLabel: {
		color: '#999',
		fontSize: 13,
		textTransform: 'uppercase',
	},
	loginUserName: {
		color: '#eee',
	},
	ticketIcon: {
		display: 'inline-block',
		width: 24,
		height: 24,
		backgroundImage: `url('${ticketIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		color: 'rgba(255, 255, 255, 1)',
		margin: 0,
	},
	accountingIcon: {
		display: 'inline-block',
		width: 24,
		height: 24,
		backgroundImage: `url('${accountingIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		color: 'rgba(255, 255, 255, 1)',
		margin: 0,
	},
	dispatchIcon: {
		display: 'inline-block',
		width: 24,
		height: 24,
		backgroundImage: `url('${dispatchIcon}')`,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		color: 'rgba(255, 255, 255, 1)',
		margin: 0,
	},
	badgeMargin: {
		paddingRight: 10,
		marginLeft: 10,
	},
	nestedItem: {
		paddingTop: 7,
		paddingBottom: 7,
	},
	notNested: {
		marginTop: 9,
		textDecoration: 'none',
	},
};

class LeftDrawer extends Component {
	constructor(props) {
		super(props);
		this.state = {
			open: true,
		};
	}

	handleLogout = () => {
		this.props.logout();
	};

	render() {
		const { authUser, drawerOpen, drawerPaper, classes, permissions } = this.props;
		if (!authUser) {
			return null;
		}

		const isHr = isPtoHr(authUser);
		//const isDispatchDept = isDispatch(authUser);
		const permissionMap = permissions ? _.keyBy(permissions) : {};
		const menuStruct = [];
		menuStruct.push({
			link: '/dashboard',
			exact: true,
			icon: <DashboardIcon className={classes.icon} />,
			label: 'Dashboard',
		});

		if (authUser.userClocksInAndOut) {
			menuStruct.push({
				nested: true,
				link: '/clockInAndOut',
				router: '/clockInAndOut',
				label: `Time Clocks`,
			});
		}

		menuStruct.push({
			link: '/driver/pickReport',
			route: '/driver/*',
			icon: <ReportIcon className={classes.icon} />,
			label: 'Employee Forms',
		});

		menuStruct.push({
			link: '/pto/request/dashboard',
			route: '/pto/request*',
			icon: <DateRangeIcon className={classes.icon} />,
			label: 'PTO Requests',
		});

		if (authUser.role !== 'driver') {
			menuStruct.push({
				nested: true,
				link: '/pto/approval/dashboard',
				route: '/pto/approval/*',
				icon: <SettingsIcon className={classes.icon} />,
				label: `PTO Approvals`,
			});

			if (isHr) {
				menuStruct.push({
					nested: true,
					link: '/pto/exported/dashboard',
					route: '/pto/exported/*',
					icon: <SettingsIcon className={classes.icon} />,
					label: `Exported PTO`,
				});
			}
		}

		if (permissionMap.canViewScheduledPto) {
			menuStruct.push({
				nested: true,
				link: '/pto/scheduled/dashboard',
				route: '/pto/scheduled/*',
				icon: <SettingsIcon className={classes.icon} />,
				label: `Scheduled PTO`,
			});
		}

		let myOpenTicketCount = 0;
		if (!_.isEmpty(this.props.myTickets)) {
			this.props.myTickets.forEach(({ status }) => {
				if (status !== 'complete') {
					myOpenTicketCount++;
				}
			});
		}

		if (authUser.role !== 'driver') {
			menuStruct.push(
				{
					link: '/ticket/list',
					route: '/ticket/(list|add|update)',
					icon: <div className={classes.ticketIcon} />,
					label: 'Tickets',
				},
				{
					showTicketBadge: true,
					nested: true,
					link: '/myTickets',
					router: '/myTickets',
					icon: <SettingsIcon className={classes.icon} />,
					label: (
						<div>
							My Tickets
							<Badge
								badgeContent={myOpenTicketCount}
								className={classes.badgeMargin}
								color="primary"
							></Badge>
						</div>
					),
				},
				{
					nested: true,
					link: '/ticket/billing/list',
					route: '/ticket/billing/list',
					label: 'Billing Tickets',
				},
				{
					nested: true,
					link: '/ticket/advancedSearch',
					router: '/ticket/advancedSearch',
					icon: <SettingsIcon className={classes.icon} />,
					label: `Advanced Search`,
				}
			);
		}

		if (permissionMap.canUpdateScheduling) {
			menuStruct.push({
				link: '/scheduling/schedule/users',
				route: '/scheduling/schedule/users',
				icon: <CalendarIcon className={classes.icon} />,
				label: 'Scheduling',
			});

			if (permissionMap.canOverrideScheduleAssignments) {
				menuStruct.push({
					nested: true,
					link: '/equipmentAssignment/list',
					router: '/equipmentAssignment/(list|add|update)',
					label: `Truck Assignments`,
				});
			}

			menuStruct.push({
				nested: true,
				link: '/scheduling/stats',
				router: '/scheduling/stats',
				label: `Terminal Stats`,
			});
		}

		if (permissionMap.canRunAttendanceReports) {
			menuStruct.push({
				nested: true,
				link: '/reports/drivers',
				route: '/reports/drivers',
				label: 'Attendance Reports',
			});
		}
		if (permissionMap.canViewLateAnalysis) {
			menuStruct.push({
				nested: true,
				link: '/reports/lateAnalysis',
				route: '/reports/lateAnalysis',
				label: 'Late Analysis',
			});
		}

		if (authUser.role !== 'driver') {
			menuStruct.push({
				link: '/dispatch',
				route: '/dispatch',
				exact: true,
				icon: <div className={classes.dispatchIcon} />,
				label: 'Dispatch',
			});
		}

		if (permissionMap.canSendMobileNotifications) {
			menuStruct.push({
				nested: true,
				link: '/dispatch/notifications',
				router: '/dispatch/notifications',
				label: `Mobile Notifications`,
			});
		}

		if (permissionMap.canViewAccounting) {
			menuStruct.push(
				{
					link: '/accounting',
					route: '/accounting',
					exact: true,
					icon: <div className={classes.accountingIcon} />,
					label: 'Accounting',
				},
				{
					nested: true,
					link: '/accounting/arImporter',
					router: '/accounting/arImporter',
					label: `AR Importer`,
				}
			);
		}

		if (permissionMap.canViewTimeClocks) {
			menuStruct.push(
				{
					link: '/timeClock',
					route: '/timeClock',
					exact: true,
					icon: <TimeClockIcon className={classes.icon} />,
					label: 'Time Clocks',
				},
				{
					nested: true,
					link: '/timeClock/reports',
					router: '/timeClock/reports',
					label: `Search & Reports`,
				}
			);
		}

		if (permissionMap.canRunTimeClockAudit) {
			menuStruct.push({
				nested: true,
				link: '/timeClock/shiftAudit',
				router: '/timeClock/shiftAudit',
				label: `Shift Audit`,
			});
		}

		if (permissionMap.canExportTimeClockInformation) {
			menuStruct.push({
				nested: true,
				link: '/timeClock/exponentExport',
				router: '/timeClock/exponentExport',
				label: `Exponent Export`,
			});
		}

		if (permissionMap.canExportTimeClockInformation) {
			menuStruct.push({
				nested: true,
				link: '/timeClock/paycomExport',
				router: '/timeClock/paycomExport',
				label: `Paycom Export`,
			});
		}

		const isAdmin = _.some(
			[
				'canAddAndUpdateUsers',
				'canAddAndUpdateTicketSettings',
				'canAuthorizeBrowserForDriverLogin',
				'canUpdateScheduling',
				'canUpdateTimeClockPermissions',
				'canUpdateJourneyPlans',
			],
			(s) => {
				return permissionMap[s];
			}
		);

		if (isAdmin) {
			menuStruct.push(
				{
					showDivider: true,
				},
				{
					link: '/administration',
					router: '/administration',
					icon: <SettingsIcon className={classes.icon} />,
					label: 'Administration',
				},
				{
					nested: true,
					link: '/fleetConfig',
					route: '/fleetConfig*',
					label: 'Fleet Config',
				}
			);
		}

		if (permissionMap.canAddAndUpdateUsers) {
			menuStruct.push({
				nested: true,
				link: '/users',
				route: '/user(/|s)',
				label: 'Users',
			});
		}

		if (permissionMap.canAddAndUpdateTicketSettings) {
			menuStruct.push(
				{
					nested: true,
					link: '/ticketCategory/list',
					route: '/ticketCategory/*',
					label: 'Ticket Categories',
				},
				{
					nested: true,
					link: '/ticketSchema/list',
					route: '/ticketSchema/*',
					label: 'Ticket Schemas',
				}
			);
		}

		if (permissionMap.canAuthorizeBrowserForDriverLogin) {
			menuStruct.push({
				nested: true,
				link: '/authorizeBrowser',
				route: '/authorizeBrowser*',
				label: 'Authorize Browser',
			});
		}

		if (permissionMap.canUpdateScheduling) {
			menuStruct.push(
				{
					nested: true,
					link: '/location/truck-terminal',
					router: '/location/*',
					label: 'Terminals',
				},
				{
					nested: true,
					link: '/equipment/truck',
					router: '/equipment/*',
					label: 'Trucks',
				}
			);
			menuStruct.push({
				nested: true,
				link: '/setupDriverRoomSchedule/',
				route: '/setupDriverRoomSchedule/*',
				label: 'Driver Room Schedule',
			});
			menuStruct.push({
				nested: true,
				link: '/scheduleConfig',
				route: '/scheduleConfig*',
				label: 'Schedule Config',
			});
		}

		if (permissionMap.canUpdateTimeClockPermissions) {
			menuStruct.push({
				nested: true,
				link: '/timeClockPermission/list',
				route: '/timeClockPermission/*',
				label: 'Supervisor Permissions',
			});
		}

		if (permissionMap.canUpdateJourneyPlans) {
			menuStruct.push({
				nested: true,
				link: '/journeyPlan/list',
				route: '/journeyPlan/*',
				label: 'Journey Plans',
			});
		}

		/** @namespace authUser.firstName **/
		/** @namespace authUser.lastName **/

		return (
			<MuiThemeProvider theme={darkTheme}>
				<Drawer variant="persistent" open={drawerOpen} classes={{ paper: drawerPaper }}>
					<Toolbar style={{ backgroundColor: 'none' }}>
						<div className={classes.logoContainer}>
							<img alt="Logo" src={sphereLogoWhiteText} className={classes.logo} />
							<div className={classes.logoSubText}>Carrier Management System</div>
						</div>
					</Toolbar>

					<Divider />

					<List style={{ textAlign: 'left', paddingTop: 20, paddingBottom: 20 }}>
						{menuStruct.map((menu, i) => {
							if (menu.showDivider) {
								return <Divider key={`divider${i}`} style={{ marginTop: 20, marginBottom: 20 }} />;
							}

							if (!menu.nested) {
								return (
									<div key={i} className={classes.notNested}>
										<Link to={menu.link} style={{ textDecoration: 'none' }}>
											<ListItem button>
												<ListItemIcon classes={{ root: classes.tightIcon }}>
													{menu.icon}
												</ListItemIcon>
												<ListItemText primary={menu.label} className={classes.iconText} />
											</ListItem>
											<Route
												exact={menu.exact}
												path={menu.route ? menu.route : menu.link}
												render={() => <div className={classes.selected} />}
											/>
											{menu.link === '/dashboard' && (
												<Route
													exact={menu.exact}
													path={'/'}
													render={() => <div className={classes.selected} />}
												/>
											)}
										</Link>
									</div>
								);
							} else {
								return (
									<div key={i} className={classes.nested}>
										<Link key={i} to={menu.link} style={{ textDecoration: 'none' }}>
											<ListItem button className={classes.nestedItem}>
												<ListItemIcon classes={{ root: classes.tightIcon }}>
													<div className={classes.nestedIcon} />
												</ListItemIcon>
												<ListItemText
													primary={menu.label}
													classes={{
														root: classes.nestedRoot,
														primary: classes.nestedText,
													}}
												/>
											</ListItem>
											<Route
												path={menu.route ? menu.route : menu.link}
												render={() => <div className={classes.selected} />}
											/>
										</Link>
									</div>
								);
							}
						})}
					</List>
					<Divider />

					<List style={{ textAlign: 'left' }}>
						<div className={classes.loginContainer}>
							<div className={classes.loginLabel}>Logged in as</div>
							<div className={classes.loginUserName}>
								{authUser.firstName} {authUser.lastName}
							</div>
						</div>

						<Link
							to={'/logout'}
							onClick={this.handleLogout}
							style={{ color: 'white', textDecoration: 'none' }}
						>
							<ListItem button>
								<ListItemIcon>
									<LogoutIcon className={classes.icon} />
								</ListItemIcon>

								<ListItemText primary="Logout" />
							</ListItem>
						</Link>
					</List>
				</Drawer>
			</MuiThemeProvider>
		);
	}
}

LeftDrawer.propTypes = {
	classes: PropTypes.object,
	drawerOpen: PropTypes.bool,
	drawerPaper: PropTypes.string,
	logout: PropTypes.func,
	permissions: PropTypes.array,
	authUser: PropTypes.object,
	myTickets: PropTypes.array,
};

// noinspection JSCheckFunctionSignatures
export default _.flow([withStyles(styles), AuthUserContainer])(LeftDrawer);
